import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { designSystem } from '@yola/ws-ui';
import { view } from '@yola/ws-sdk';
import ElementSettingsContext from '../../../helpers/element-settings-context';

const { Box, ActionRadioGroup } = designSystem;

const HORIZONTAL_ALIGN_ATTRIBUTE = 'h-align';
const VERTICAL_ALIGN_ATTRIBUTE = 'v-align';

const getSelectedValue = (state, elementId, choices, attribute) => {
  let value =
    get(state, `${elementId}.${attribute}`) ||
    view.accessors.getElementAttribute(elementId, attribute);

  if (!value) {
    const element = view.accessors.getLiveElement(elementId);
    const computedStyles = window.getComputedStyle(element);

    if (attribute === HORIZONTAL_ALIGN_ATTRIBUTE) {
      value = computedStyles.justifyContent;
    } else {
      value = computedStyles.alignItems;
    }
  }

  return choices.find((choice) => choice.value === value)?.id || choices[0].value;
};

const horizontalChoices = [
  {
    id: 'left',
    glyph: 'align-start-horizontal',
    value: 'left',
  },
  {
    id: 'center',
    glyph: 'align-center-horizontal',
    value: 'center',
  },
  {
    id: 'right',
    glyph: 'align-end-horizontal',
    value: 'right',
  },
];

const verticalChoices = [
  {
    id: 'start',
    glyph: 'align-start-vertical',
    value: 'start',
  },
  {
    id: 'center',
    glyph: 'align-center-vertical',
    value: 'center',
  },
  {
    id: 'end',
    glyph: 'align-end-vertical',
    value: 'end',
  },
];

const defaultOption = {};

function ColumnsAlignmentsOption({ elementId = null, option = defaultOption, settingId = '' }) {
  const { state, updateState, callbacks } = useContext(ElementSettingsContext);

  const onHorizontalChange = (choice) => {
    updateState(option, {
      [elementId]: {
        [HORIZONTAL_ALIGN_ATTRIBUTE]: choice.value,
      },
    });
    callbacks.onOptionClicked({ optionId: 'horizontal-alignment', settingId });
  };

  const onVerticalChange = (choice) => {
    updateState(option, {
      [elementId]: {
        [VERTICAL_ALIGN_ATTRIBUTE]: choice.value,
      },
    });
    callbacks.onOptionClicked({ optionId: 'vertical-alignment', settingId });
  };

  if (!elementId) return null;

  const horizontalSelected = getSelectedValue(
    state,
    elementId,
    horizontalChoices,
    HORIZONTAL_ALIGN_ATTRIBUTE
  );
  const verticalSelected = getSelectedValue(
    state,
    elementId,
    verticalChoices,
    VERTICAL_ALIGN_ATTRIBUTE
  );

  return (
    <Box padding="spacing-s">
      <div className="ws-columns-alignments-option">
        <ActionRadioGroup
          options={horizontalChoices}
          selectedId={horizontalSelected}
          onChange={onHorizontalChange}
          gap="auto"
        />
        <ActionRadioGroup
          options={verticalChoices}
          selectedId={verticalSelected}
          onChange={onVerticalChange}
          gap="auto"
        />
      </div>
    </Box>
  );
}

ColumnsAlignmentsOption.propTypes = {
  elementId: PropTypes.string,
  option: PropTypes.shape({}),
  settingId: PropTypes.string,
};

export default ColumnsAlignmentsOption;
